var messages = {
  networkError: 'Network error',
  uploadPending: 'Waiting for Upload...',
  uploadFailed: 'Upload Failed',
  uploading: 'Uploading',
  fileUploading: 'File uploading',
  uploadFile: 'Upload file',
  clickOrDragToUpload: 'Click or drag file to upload',
  ctrlVToPasteImage: 'Ctrl + V to paste image',
  uploadImage: 'Upload image'
};
export default messages;